import React,{useState} from 'react';
import NCUData from './NCUData';
import NCUTrackersList from './NCUTrackersList';
import { useParams } from 'react-router-dom';
import './VerNCU.css';
import { BsArrowRightCircle, BsArrowLeftCircle } from 'react-icons/bs';

function VerNCU(){
    const { ncu } = useParams();
    const [nombreNCU,setNombreNCU] = useState();
    const childToParent = (nombreNCU) => {
        setNombreNCU(nombreNCU)
      }

    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    //**********************************************************
    var numberNCU = (JSON.parse(sessionStorage.getItem("NCUConfiguration"))).length;
    function handleClickChangeLeft(){
        if(parseInt(ncu) === 1){
            window.location = '/#/ncu/' + numberNCU;
        }else{
            window.location ='/#/ncu/' + (parseInt(ncu) - parseInt(1));
        }
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    function handleClickChangeRight(){
        if(parseInt(ncu) === numberNCU){
            window.location = '/#/ncu/1';
        }else{
            window.location ='/#/ncu/' + (parseInt(ncu) + parseInt(1));
        }
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    return (
        <div className='div-body-ncu'>
            <div className='div-ct-title'>
                <div className='div-arrow-icon-ct'><BsArrowLeftCircle size={30} className='arrow-icon-ct' onClick={() => {handleClickChangeLeft()}}/></div>
                <div style={{position: 'relative', float: 'left'}}><h3>NCU {ncu}</h3></div>
                <div className='div-arrow-icon-ct'><BsArrowRightCircle size={30} className='arrow-icon-ct' onClick={() => {handleClickChangeRight()}}/></div>
            </div>
            <NCUData childToParent={childToParent} code={code} />
            <NCUTrackersList childToParent={childToParent} code={code} />
        </div>
    );
};

export default VerNCU;